import { render, staticRenderFns } from "./RenounceSaving.vue?vue&type=template&id=27728c37&"
import script from "./RenounceSaving.vue?vue&type=script&lang=js&"
export * from "./RenounceSaving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports